import { useContext } from 'react';

import { OnlineStatusContext } from 'contexts/OnlineStatusContext';

export const useOnlineStatus = () => {
  const onlineStatusContext = useContext(OnlineStatusContext);

  return onlineStatusContext;
};
